<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin ">
          <!-- //****************** -->

          <button [disabled]="exclusionRAC_APROVE!=1" class="approved" *ngIf="isApproved && actionmode == 'Edit' && rejected!=2">

            <span class="bold">Approved</span>
          </button>
          <input type="button" [disabled]="exclusionRAC_APROVE!=1" class="btn btn-success commonbutt"
            style="width: 80px;font-weight: 700" value="Active" id="btnname" (click)="changeName()"
            *ngIf="isApproved && actionmode == 'Edit'  && rejected!=2" />
          <!-- //****************** -->

          <button *ngIf="!viewpage" [disabled]="            
              showList == true ||
              viewpage == true ||
              nameExist       
            " class="btn btn-success commonbutt" type="button" (click)="submitData1()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button [disabled]="            
          showList == true ||
          viewpage == true ||
          nameExist       
        " class="btn btn-success commonbutt" type="button" *ngIf="!isApproved && updateApprove && exclusionRAC_APROVE == '1'"
            data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button [disabled]="            
              showList == true ||
              viewpage == true ||
              nameExist       
            " class="btn btn-warning commonbutt" type="button"
            *ngIf="!isApproved && updateApprove && exclusionRAC_APROVE == '1'" data-toggle="modal" data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="errwrap">
                        <div class="errdiv1" id="err"></div>
                      </div>
                      <div class="col-lg-3">
                        <label>Select Supplier</label>
                        <select class="form-control" [(ngModel)]="screen_details.SUPPLIER_ID"
                          (change)="onSelectedId(); checkNames()" [disabled]="actionmode == 'Edit'">
                          <option disabled value="">--Select Supplier--</option>
                          <option value="{{supplier.SUPPLIER_ID}}" *ngFor="let supplier of suppliers">{{
                            supplier.SUPPLIER_NAME }}</option>
                        </select>
                        <span *ngIf="nameExist" style="color: red">Supplier name already exist</span>
                      </div>
                      <div class="clr"></div>
                      <div class="divider"></div>
                      <br />
                      <div class="clr"></div>
                      <div class="cwrap">
                        <div style="padding: 5px;float: left;background: #c2c2c2;">
                          <div class="clbldiv">Selected Airlines</div>
                          <div class="cdiv">
                            <ol type="A" *ngFor="let q of countryArray">
                              <li class="listb">
                                <input type="checkbox" class="chekb" (change)="
                                    checkCountry($event, q.AIRLINE_ID, 1)
                                  " />{{ q.AIRLINE_NAME }}({{ q.AIRLINE_CODE }})
                              </li>
                            </ol>
                          </div>
                        </div>
                        <div class="arrows">
                          <div>
                            <button (click)="rightTransfer();changeState();">
                              <span class="glyphicon glyphicon-chevron-right"></span>
                            </button>
                          </div>
                          <div>
                            <button (click)="leftTransfer();changeState();">
                              <span class="glyphicon glyphicon-chevron-left"></span>
                            </button>
                          </div>
                        </div>
                        <div style="padding: 5px;float: left;background: #c2c2c2;">
                          <div class="clbldiv">Excluded Airlines</div>
                          <div class="rcdiv">
                            <ol type="A" *ngFor="let q of leftcountryArray">
                              <li class="listb">
                                <input type="checkbox" class="chekb" (change)="
                                    leftCheckCountry($event, q.AIRLINE_ID)
                                  " />{{ q.AIRLINE_NAME }}({{ q.AIRLINE_CODE }})
                              </li>
                            </ol>
                          </div>
                        </div>
                        <div class="clr"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" (click)="clearRemark()" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up" style="margin-right: 10px"></span>Do you want to approve ?
        </h4>
      </div>

      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea [(ngModel)]="exclusionApprove_details.APPROVAL_REMARKS" 
          (input)="getremark($event.target.value)"
            (blur)="checkRemarkLength($event.target.value)" rows="8" cols="20" type="text" 
            class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span *ngIf="minRemark" 
          class="m-form__help" style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="!aprvbtn" 
        class="btn btn-success " type="button" 
        (click)="aproveReject(1)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>

        <button class="btn btn-warning " 
        (click)="clearRemark()" type="button" data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<!-- ########## -->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" class="close" (click)="clearRemark()" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-down" style="margin-right: 10px"></span>Do you want to reject ?
        </h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea [(ngModel)]="exclusionApprove_details.APPROVAL_REMARKS" 
          rows="8" (input)="getremark($event.target.value)"
             cols="20" type="text" class="form-control m-input"
             (blur)="checkRemarkLength($event.target.value)"
            placeholder="Enter  Remarks">
          </textarea>
          <span class="m-form__help" *ngIf="minRemark" 
          style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="!aprvbtn" 
        class="btn btn-success" type="button" 
        (click)="aproveReject(2)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>
        <button class="btn btn-warning " 
        data-dismiss="modal"
        (click)="clearRemark()" type="button" >
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ########## -->

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>{{ screentitle }} Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" *ngIf="exclusionRAC_ADD == '1'" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div style="padding: 2% 2% 2% 2%">
                <div>
                  <div>
                    <div class="col-lg-3">
                      <label>Select Supplier</label>
                      <select class="form-control" [(ngModel)]="search_details.SUPPLIER_ID">
                        <option disabled value="">--Select Supplier--</option>
                        <option value="{{supplier.SUPPLIER_ID}}" *ngFor="let supplier of suppliers">{{
                          supplier.SUPPLIER_NAME }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="btn clear-button button-margin">
                  <button class="btn btn-primary commonbutt" style="margin-left: 195px;
                    width: 83px;
                    margin-top: 25px;" (click)="searchData()" type="button">
                    <em class="fa fa-search "></em>&nbsp;Search
                  </button>
                </div>
              </div>

              <div class="errwrap">
                <div class="errdiv1" id="err"></div>
              </div>

              <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                <table aria-describedby="airlineExclusionDetails" class="table table-striped" [mfData]="serachtabledata"
                  [mfRowsOnPage]="5">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 20%" *ngIf="exclusionRAC_VIEW == '1' && exclusionRAC_EDIT == '1'">
                        Actions
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="parent_table_Id">Supplier Name
                        </mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="JOURNEY_NAME">Airline Name
                        </mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="JOURNEY_NAME">Airline code</mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="JOURNEY_NAME">status</mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let data of (serachtabledata
                          | paginate: { itemsPerPage: 3, currentPage: p });
                        let i = index
                      ">
                      <td *ngIf="(exclusionRAC_VIEW == '1' || exclusionRAC_EDIT == '1') && i==0">
                        <button class="btn btn-default btn-circle" *ngIf="exclusionRAC_VIEW == '1'" type="button"
                          (click)="showFormData(data.SUPPLIER_ID, 1, 1, 1)">
                          <em class="fa fa-eye"></em>
                        </button>
                        <span *ngIf="data.STATUS != '2' && data.PRE_APPROVE != '1'">
                          <button class="btn btn-default btn-circle" *ngIf="exclusionRAC_EDIT == '1'" type="button" (click)="
                              showFormData(
                                data.SUPPLIER_ID,
                                2,
                                data.STATUS,
                                data.APPROVAL_STATUS
                              )
                            ">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </span>
                      </td>
                      <td *ngIf="i != 0"></td>
                      <td *ngIf="i == 0">{{ data.SUPPLIER_NAME }}</td>
                      <td *ngIf="i != 0"></td>
                      <td>{{ data.AIRLINE_NAME }}</td>
                      <td>{{ data.AIRLINE_CODE }}</td>
                      <td *ngIf="i != 0"></td>
                      <td *ngIf="i == 0">
                        <div *ngIf="
                            data.APPROVAL_STATUS == 0 &&
                            data.STATUS == 0 &&
                            data.PRE_APPROVE != 1
                          ">
                          <span class="icls1">
                            <button class="btn commonbutt zol1">
                              Inactive
                            </button>

                            <span class="tooltiptext">Not Approved</span>
                          </span>
                        </div>

                        <div *ngIf="
                            data.APPROVAL_STATUS == 1 && data.PRE_APPROVE != 1
                          ">
                          <span class="icls1">
                            <button class="btn  commonbutt zol" *ngIf="data.STATUS == 1">
                              Active
                            </button>

                            <button class="btn  commonbutt zol1" *ngIf="data.STATUS == 0">
                              Inactive
                            </button>
                            <span class="tooltiptext"> Approved </span>
                          </span>
                        </div>
                        <div *ngIf="
                          data.APPROVAL_STATUS == 0 && data.PRE_APPROVE == 1
                        ">
                          <span class="icls1">
                            <button class="btn  commonbutt zol">
                              Active
                            </button>
                            <span class="tooltiptext"> Approved </span>
                          </span>
                        </div>
                        <div *ngIf="data.APPROVAL_STATUS == 2 && data.STATUS == 2">
                          <span class="icls5">
                            <button class="btn  commonbutt zol1">
                              Inactive
                            </button>

                            <span class="tooltiptext">Rejected</span>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5">
                        <pagination-controls 
                        (pageChange)="p = $event"></pagination-controls>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div *ngIf="loader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode == 'View'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" *ngIf="showList == !false">{{ viewTitle }}</h1>
      <h1 class="screen-title" *ngIf="showList == false">
        {{ insertDataTitle }}
      </h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'View'" 
        class="btn back-button button-margin ">
          <button class="btn btn-danger commonbutt" 
          (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="tdive">
                        <table aria-describedby="airlineSupplierDetails" class="viewtable">
                          <div *ngFor="let q of serachTableInfo; let i = index">
                            <tr *ngIf="i == 0">
                              <th scope="col"><span class="vlbl">Supplier name:</span></th>
                              <td>
                                <span class="vVal">{{ q.SUPPLIER_NAME }}</span>
                              </td>
                            </tr>

                            <tr *ngIf="i == 0">
                              <th scope="col"><span class="vlbl"> Airline name: </span></th>
                              <td>
                                <ul *ngFor="let item1 of serachTableInfo">
                                  <li class="vVal">{{ item1.AIRLINE_NAME }}</li>
                                </ul>
                              </td>
                            </tr>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>